import { ArrowLeft } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

interface IProps {
    topContent?: any;
    leftContent?: any;
    title: any;
    desc?: string;
    rightSideContent?: any;
    mainContainerClassName?: string;
    countBadge?: any;
    rightClassName?: string;
    leftClassName?: string;
    isShowNotificationBox?: boolean;
    Icon?: React.ElementType;
    moduleIconClassName?: string;
    isDisplayBackArrow?: boolean;
    handleNavigateBackArrow?: () => void;
}

const Header = ({
    topContent,
    leftContent,
    title,
    desc,
    rightSideContent,
    mainContainerClassName,
    countBadge,
    rightClassName = '',
    leftClassName,
    Icon,
    moduleIconClassName,
    isDisplayBackArrow = false,
    handleNavigateBackArrow,
}: IProps) => (
    <>
        {topContent}

        <div
            className={`flex flex-wrap lg:items-center lg:flex-row md:flex-col flex-row items-start justify-between sm:gap-3 gap-2 border-b border-borderPrimary pb-3
					${mainContainerClassName}
				`}
        >
            <div className={`md:w-auto w-full ${leftClassName}`}>
                {isDisplayBackArrow && (
                    <ButtonCmp onClick={handleNavigateBackArrow} className="btn_secondary_black lg:!px-[9px] !px-2">
                        <ArrowLeft className="w-4 h-4" />
                    </ButtonCmp>
                )}
                <div className="flex items-center md:gap-2 gap-1 flex-wrap w-full">
                    <div className="flex items-center gap-x-2">
                        {Icon && <Icon className={`w-4 h-4 ${moduleIconClassName}`} />}
                        <h1 className="text-gray-900 text-sm lg:text-lg font-semibold">{title}</h1>
                    </div>
                    {leftContent}
                    {countBadge}
                </div>
                {desc && <p className="text-grayLight600 text-sm font-normal leading-normal mt-1">{desc}</p>}
            </div>
            <div className={`flex flex-wrap sm:flex-row flex-col md:justify-end lg:gap-4 gap-3 flex-none md:w-auto w-full ${rightClassName ?? ''}`}>{rightSideContent && rightSideContent}</div>
        </div>
    </>
);

export default Header;
